import localScaleManager from "../../../helpers/LocalScaleManager";

export class TableTimer {
  constructor(scene, table) {
    this.scene = scene;
    this.table = table;
    this.bg = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "table-timer-bg")
      .setOrigin(0)
      .setAlpha(0.7);
    this.table.poolArray.push(this.bg);

    this.timerIcon = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "table-timer")
      .setOrigin(0);
    this.table.poolArray.push(this.timerIcon);

    this.totalSeconds = 30;
    this.remainingTime = 30;
    this.timerText = this.scene.add
      .bitmapText(0, 0, "digital", "00:00:00")
      .setOrigin(0);
    this.timerText.setData("width", this.timerText.width);
    this.timerText.setData("height", this.timerText.height);
    this.table.poolArray.push(this.timerText);

    this.timer = scene.time.addEvent({
      delay: 1000, // ms
      callback: this.timeEvent,
      callbackScope: this,
      repeat: -1,
    });
    this.message = this.scene.add
      .bitmapText(0, 0, "HelveticaNeueTeal", "Tournament will start after: ")
      .setOrigin(0.5);
    this.message.setData("width", this.message.width);
    this.message.setData("height", this.message.height);

    // this.message = this.scene.add.text(0, 0, "", {
    //   fontFamily: "HelveticaNeue",
    //   fontSize: 1,
    //   color: "#c6bfb1",
    //   backgroundColor: "#000000",
    //   align: "center",
    // });
    // this.message.setText("Tournament will start after: ").setOrigin(0.5);
    this.table.poolArray.push(this.message);

    this.timer.paused = true;
    this.isShowed = false;
    this.children = this.scene.add.group();
    this.children.addMultiple([
      this.bg,
      this.timerIcon,
      this.timerText,
      this.message,
    ]);
    Phaser.Actions.SetAlpha(this.children.getChildren(), 0.7);
    Phaser.Actions.SetDepth(this.children.getChildren(), 20);
    Phaser.Actions.SetVisible(this.children.getChildren(), false);
    this.table.poolArray.push(this.children);
    this.tableY = 0;
    this.tableHeight = 0;
    this.msgTween = null;
    this.msgInitScale = 0;
  }
  timeEvent() {
    this.totalSeconds--;
    // if(this.totalSeconds >= 3600) {
    this.timerText.setText(
      `${new Date(this.totalSeconds * 1000).toISOString().substr(11, 8)}`
    );
    // }
    // else {
    //     this.timerText.setText(`${new Date(this.totalSeconds * 1000).toISOString().substr(14, 5)}`);
    // }
    // this.timerText.setX(this.bg.x + (this.bg.displayWidth - this.timerText.width) / 2);
    if (this.totalSeconds === 0) {
      this.timer.paused = true;
      this.totalSeconds = this.remainingTime;
    }
  }
  /**
   * @param time{number} remainingTime (ms)
   */
  // show(time, isTournamentTimer) {
  //   this.startTimer(time);
  //   if (!this.isShowed) {
  //     this.isShowed = true;
  //     Phaser.Actions.SetVisible(this.children.getChildren(), true);
  //     if(isTournamentTimer) {
  //       this.updateMessage("Tournament will start after: ");
  //     } else {
  //       this.message.setVisible(false);
  //     }
  //     Phaser.Actions.IncY(
  //       this.children.getChildren(),
  //       this.bg.displayHeight * 2
  //     );
  //     this.scene.tweens.add({
  //       targets: this.children.getChildren(),
  //       duration: 400,
  //       ease: "Back",
  //       y: `-=${this.bg.displayHeight * 2}`,
  //       alpha: 0.7,
  //     });
  //   }
  // }
  show(time, message, tween) {
    if (time) {
      this.startTimer(time);
      Phaser.Actions.SetVisible(this.children.getChildren(), true);
    } else Phaser.Actions.SetVisible(this.children.getChildren(), false);
    if (message) {
      if (this.message.scale !== this.msgInitScale) {
        this.message.setScale(this.msgInitScale);
      }
      this.updateMessage(message);
      if (tween) {
        // if (this.message.font !== "HelveticaNeueTeal") {
        //   this.message.setFont("HelveticaNeueTeal");
        // }
        if (!this.msgTween) {
          this.msgTween = this.scene.tweens.add({
            targets: this.message,
            scaleX: this.message.scaleX * 1.1,
            scaleY: this.message.scaleY * 1.1,
            ease: "Sine.easeInOut",
            duration: 2000,
            repeat: -1,
            yoyo: true,
          });
        }
      } else {
        // if (this.message.font !== "HelveticaNeue") {
        //   this.message.setFont("HelveticaNeue");
        // }
        if (this.msgTween) {
          this.msgTween.destroy();
          this.msgTween = null;
        }
      }
      if (!this.message.visible) this.message.setVisible(true);
    } else {
      if (this.message.visible) this.message.setVisible(false);
    }
    // if (!this.isShowed) {
    // this.initPositions();
    // this.isShowed = true;
    // Phaser.Actions.IncY(
    //   this.children.getChildren(),
    //   this.bg.displayHeight * 2
    // );
    // this.scene.tweens.add({
    //   targets: this.children.getChildren(),
    //   duration: 400,
    //   ease: "Back",
    //   y: `-=${this.bg.displayHeight * 2}`,
    //   alpha: 0.7,
    //   onComplete: () => {
    //     Phaser.Actions.SetAlpha(this.children.getChildren(), 0.7);
    //   },
    // });
    // }
  }
  hide() {
    // if (this.isShowed) {
    // this.isShowed = false;
    // this.scene.tweens.add({
    //   targets: this.children.getChildren(),
    //   duration: 200,
    //   ease: "Back",
    //   y: `+=${this.bg.displayHeight}`,
    //   alpha: 0,
    //   onComplete: () => {
    //     this.initPositions();
    // Phaser.Actions.IncY(
    //   this.children.getChildren(),
    //   -this.bg.displayHeight
    // );
    // Phaser.Actions.SetAlpha(this.children.getChildren(), 0);
    Phaser.Actions.SetVisible(this.children.getChildren(), false);
    this.timer.paused = true;
    if (this.msgTween) {
      this.msgTween.destroy();
      this.msgTween = null;
    }
    // },
    // });
    // }
  }
  // handleGameState(gameState) {
  //   let isTournamentTimer = this.table.isTournamentTable() && gameState.tournamentState === "Matching";
  //   if (gameState.playerInfo) {
  //     if (gameState.playerInfo.state === "SitOut" || isTournamentTimer) {
  //       const time = gameState.playerInfo.state === "SitOut" ? gameState.playerInfo.timeRemaining : gameState.timeRemaining;
  //       this.show(time, isTournamentTimer);
  //     } else {
  //       this.hide();
  //     }
  //   } else {
  //     if(isTournamentTimer) this.show(gameState.timeRemaining, true);
  //     else this.hide()
  //   }
  // }
  handleGameState(gameState) {
    // setInterval(() => {
    //   setTimeout(() => {
    //     this.show(
    //       30000,
    //       "Enjoy a short break. We'll be back in:"
    //     );
    //     }, 100)
    //     setTimeout(() => {
    //       this.hide();
    //       }, 1050)
    //   setTimeout(() => {
    //     this.show(null, "We're on standby for others to add-on.");
    //     }, 1060)
    //     setTimeout(() => {
    //       this.hide();
    //       }, 10200)
    // }, 5000)
    // return
    if (gameState.playerInfo && gameState.playerInfo.state === "SitOut") {
      this.show(gameState.playerInfo.timeRemaining, "");
    } else if (
      this.table.isTournamentTable() &&
      gameState.tournamentState === "Matching"
    ) {
      this.show(
        gameState.timeRemaining,
        "Get ready, players! Tournament begins in: "
      );
    } else if (gameState.state === "AddOnPhase") {
      this.show(null, "We're on standby for others to add-on.", true);
    } else if (gameState.state === "AddOnBreak") {
      this.show(null, "Waiting for other tables to finish before add-on.", true);
    } else if (gameState.state === "waitingBeforeLR") {
      this.show(null, "Waiting for the late registration period to end", true);
    } else if (gameState.state === "Break") {
      if (!gameState.waitingForBreak) {
        this.show(
          gameState.timeRemaining,
          "Enjoy a short break. We'll be back in:"
        );
      } else {
        this.show(null, "Waiting for other tables to finish before the break", true);
      }
    } else if (gameState.state === "Idle" && gameState.finalTables) {
      this.show(null, "Waiting for other tables to finish their game.", true);
    } else {
      this.hide();
    }
  }
  /**
   * @param time{number} remainingTime (ms)
   */
  startTimer(time) {
    if (time <= 0) time = 0;
    this.remainingTime = Math.trunc(time / 1000);
    this.totalSeconds = this.remainingTime;
    this.timer.paused = false;
  }

  updateMessage(str) {
    this.message.setText(str);
  }
  /***
   * @param width {number} width of table
   * @param height {number} width oftable
   * @param initX {number} table left x
   * @param initY {number} table left y
   */
  positionControls(width, height, initX, initY) {
    const bgSize = width / 3;
    this.tableY = initY;
    this.tableHeight = height;
    localScaleManager.scaleSprite(this.bg, bgSize, bgSize, 0, 1, true);
    this.bg.setPosition(
      initX + (width - this.bg.displayWidth) / 2,
      initY + (height / 2 - this.bg.displayHeight * 1.8)
    );

    localScaleManager.scaleSprite(
      this.timerIcon,
      bgSize / 6,
      bgSize / 6,
      0,
      1,
      true
    );
    this.timerIcon.setPosition(
      this.bg.x + this.timerIcon.displayWidth / 2,
      this.bg.y + (this.bg.displayHeight - this.timerIcon.displayHeight) / 2
    );

    this.textSize = this.bg.displayWidth / 2;
    localScaleManager.scaleBitMapText(
      this.timerText,
      (this.bg.displayWidth * 3) / 5,
      this.bg.displayHeight / 2,
      0,
      1,
      false
    );
    this.timerText.setPosition(
      (this.bg.displayWidth +
        this.timerIcon.x +
        this.timerIcon.displayWidth +
        this.bg.x -
        this.timerText.width) /
        2,
      this.timerIcon.y + this.timerText.height / 1.3
    );

    // this.message.setPosition( this.bg.x - this.bg.displayWidth / 5,
    //   this.bg.y - this.bg.displayHeight / 4
    // );
    localScaleManager.scaleBitMapText(
      this.message,
      this.bg.displayWidth,
      this.bg.displayHeight / 4,
      0,
      1,
      false
    );
    this.message.setPosition(
      initX + width / 2,
      this.bg.y - this.bg.displayHeight / 4
    );
    this.msgInitScale = this.message.scale;
    // this.message.setFontSize(this.bg.displayHeight / 5);
    // this.message.setWordWrapWidth(this.bg.displayWidth * 3);
  }
  /***
   * @param width {number} width of table
   * @param height {number} width oftable
   * @param initX {number} table left x
   * @param initY {number} table left y
   */
  reposition(width, height, initX, initY) {
    this.tableY = initY;
    this.tableHeight = height;

    this.bg.setPosition(
      initX + (width - this.bg.displayWidth) / 2,
      initY + (height / 2 - this.bg.displayHeight * 1.8)
    );
    this.timerIcon.setPosition(
      this.bg.x + this.timerIcon.displayWidth / 2,
      this.bg.y + (this.bg.displayHeight - this.timerIcon.displayHeight) / 2
    );
    this.timerText.setPosition(
      (this.bg.displayWidth +
        this.timerIcon.x +
        this.timerIcon.displayWidth +
        this.bg.x -
        this.timerText.width) /
        2,
      this.timerIcon.y + this.timerText.height / 1.3
    );

    this.message.setPosition(
      initX + width / 2,
      this.bg.y - this.bg.displayHeight / 4
    );
  }
  // initPositions() {
  //   this.bg.setY(
  //     this.tableY + (this.tableHeight / 2 - this.bg.displayHeight * 1.8)
  //   );
  //   this.timerIcon.setY(
  //     this.bg.y + (this.bg.displayHeight - this.timerIcon.displayHeight) / 2
  //   );
  //   this.timerText.setY(this.timerIcon.y + this.timerText.height / 1.3);
  //   this.message.setY(this.bg.y - this.bg.displayHeight / 4);
  // }
}
